import { ATTACH_FILE_PANEL_MIN_WIDTH } from '@/components/create/AttachFilePanel';
import { Box, Theme } from '@mui/material';
import React, { FC, PropsWithChildren, ReactElement } from 'react';

/**
 * The photo panels of a letter, laid out the same way on every step that draws them.
 */
export const PhotoPanelGrid: FC<PropsWithChildren> = (props: PropsWithChildren): ReactElement => (
  <Box
    sx={{
      maxWidth: (theme: Theme): string => `calc(${2 * ATTACH_FILE_PANEL_MIN_WIDTH}px + ${theme.spacing(1.5)})`,
    }}>
    <Box
      aria-label={'attach-photo-grid'}
      sx={{
        display: 'grid',
        gap: 1.5,
        width: '100%',
        gridTemplateColumns: `repeat(auto-fill, minmax(${ATTACH_FILE_PANEL_MIN_WIDTH}px, 1fr))`,
      }}>
      {props.children}
    </Box>
  </Box>
);
